<template>
  <div class="min-w-full">
    <div class="w-full grid grid-cols-2 gap-4">
      <div>
        <h1 class="mb-8 font-bold text-3xl">
          Access Tokens
        </h1>
      </div>
      <div class="text-right">
        <div v-show="!toggle" class="cursor-pointer duration-30 text-indigo-500" @click="toggle = !toggle">
          <i class="fas fa-plus text-3xl" />
        </div>
        <div v-show="toggle" class="cursor-pointer duration-300 text-indigo-500" @click="toggle = !toggle">
          <i class="fas fa-minus text-3xl" />
        </div>
      </div>
    </div>
    <div v-if="$page.props.flash.success"
      class="flex items-center justify-between mb-8 max-w-full bg-green-500 rounded">
      <div class="flex items-center">
        <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
        </svg>
        <div class="py-4 text-white text-sm font-medium">{{ $page.props.flash.success }}</div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow">

      <div v-show="toggle" class="p-6 min-w-max border-b-2">
        <form id="tokenForm" name="tokenForm" @submit.prevent="addToken">
          <h2 class="font-bold mb-4">
            Create Token
          </h2>
          <text-input id="token" v-model="tokenForm.name" :error="tokenForm.errors.name" name="token"
            class="pb-4 w-full" label="Name" />
          <div class="flex justify-center items-center">
            <div>
              <loading-button :loading="tokenForm.processing" class="btn-indigo ml-auto" type="submit">Create
                Token</loading-button>
            </div>
          </div>
        </form>
      </div>
      <div class="p-6">
        <div class="bg-white rounded shadow">
          <table class="table-fixed p-5 w-full">
            <thead>
              <tr class="text-left font-bold">
                <th class="w-1/5 p-5">ID</th>
                <th class="w-3/5 p-5">Name</th>
                <th class="w-1/5 p-5" />
              </tr>
            </thead>
            <tbody>
              <tr v-for="token in tokens" :key="token.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t p-2 text-center">
                  <div>
                    <div class="w-full">
                      {{ token.id }}
                    </div>
                  </div>
                </td>
                <td class="border-t p-2">
                  <div class="w-full text-xs mb-4">Created at {{ datestamp(token.created_at) }} {{
                    timestamp(token.created_at) }}</div>
                  <div class="w-full text-m font-semibold">{{ token.name }}</div>
                </td>
                <td class="border-t p-2 text-right">
                  <button class="text-red-600 px-2 py-2 hover:underline" tabindex="-1" @click="destroyToken(token.id)">
                    <i class="ml-2 fas fa-times text-red-500" />
                  </button>
                </td>
              </tr>
              <tr v-if="tokens.length === 0">
                <td class="border-t p-2 text-center" colspan="4">No Tokens.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import { router } from '@inertiajs/vue3'

export default {
  name: 'AccessTokens',
  components: {
    LoadingButton,
    TextInput,
  },
  props: {
    user: Object,
    tokens: Object,
  },

  data() {
    return {
      tokenForm: router.form({
        name: null,
      }),
      toggle: false,
    }
  },
  computed: {
    timeFormatted() {
      return moment(this.givenDate).format('YYYY')
    },
  },
  methods: {
    timestamp: function (date) {
      return moment(date).format('h:mm A')
    },
    datestamp: function (date) {
      return moment(date).format('MM/DD/YY')
    },
    addToken() {
      //console.log(this.tokenForm.name)
      this.tokenForm.post('/token', {
        onSuccess: () => {
          this.tokenForm.reset('name')
        },
      })
      //   this.tokenForm.name = ''
    },
    destroyToken(id) {
      router.delete(('/token/' + id), { only: ['tokens'], preserveScroll: true })
    },
  },
}

</script>
